import { Input, Form } from "antd";
import React, { useContext, } from 'react';
import { Settings } from './Settings';
import { Resizer, useNode, FormContext } from 'wsc-react-custom-form';
import { extractValueWithKeyFromObject } from "@/utils/utils";
import { getLayout } from "../../mini-helper";
const defaultProps = {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    hidden: 'false',
    map: [
        {
            name: 'busi-id',
            dataKey: 'data/id',
        }
    ],
    label: '标题',
    labelSpan: 6,
    labelOffset: 0,
    wrapperSpan: 18,
    wrapperOffset: 0,
    width: '100%',
    height: 'auto',
    padding: ['0', '0', '0', '0'],
    margin: ['0', '0', '0', '0'],
    background: { r: 255, g: 255, b: 255, a: 1 },
    color: { r: 0, g: 0, b: 0, a: 1 },
    shadow: 0,
    radius: 0,
    fillSpace: 'no',
    visible: 'true',
    required: 'true',
    rules: [{ required: true, message: '请选择' }],
}
export const MiniBusiDataMap = (props) => {
    props = {
        ...defaultProps,
        ...props,
    };
    const {
        label,
        labelSpan,
        labelOffset,
        wrapperSpan,
        wrapperOffset,
        map,
        hidden,
        visible,
        flexDirection,
        alignItems,
        justifyContent,
        fillSpace,
        background,
        color,
        required,
        padding,
        margin,
        shadow,
        radius,
        rules,
    } = props;
    const { formdata } = useContext(FormContext);

    const {
        connectors: { connect },
    } = useNode((node) => ({
        selected: node.events.selected,
    }));
    const itemLayout = getLayout(labelSpan, labelOffset, wrapperSpan, wrapperOffset);
    if (!map || !Array.isArray(map) || map.length === 0) return null;
    // 支持自定义校验
    const isRequired = required === 'true' || rules?.some(
        rule => typeof rule !== "function" && rule.required
    );
    return <div style={{
        width: "100%"
    }} ref={connect}>
        {
            map.map(item => {
                const { name, dataKey } = item;
                // dataKey: data/id
                const value = extractValueWithKeyFromObject(formdata, dataKey);
                return (
                    <Resizer
                        propKey={{ width: 'width', height: 'height' }}
                        style={{
                            justifyContent,
                            flexDirection,
                            alignItems,
                            background: `rgba(${background.r}, ${background.g}, ${background.b}, ${background.a})})`,
                            color: `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`,
                            padding: `${padding[0]}px ${padding[1]}px ${padding[2]}px ${padding[3]}px`,
                            margin: `${margin[0]}px ${margin[1]}px ${margin[2]}px ${margin[3]}px`,
                            boxShadow:
                                shadow === 0
                                    ? 'none'
                                    : `0px 3px 100px ${shadow}px rgba(0, 0, 0, 0.13)`,
                            borderRadius: `${radius}px`,
                            flex: fillSpace === 'yes' ? 1 : 'unset',
                            display: visible === 'true' ? 'flex' : "none",
                        }}
                    >
                        <Form.Item
                            style={{ width: "100%" }}
                            {...itemLayout}
                            key={name}
                            label={label}
                            rules={rules}
                            name={name}
                            initialValue={value}
                            disabled
                            required={isRequired}
                            hidden={hidden === 'true'}
                        >

                        </Form.Item>
                    </Resizer>
                );
            })
        }
    </div>

};

MiniBusiDataMap.category = "流程";
MiniBusiDataMap.thumb = "https://via.placeholder.com/300x200.png";

MiniBusiDataMap.craft = {
    displayName: 'MiniBusiDataMap',
    props: {
        ...defaultProps
    },
    related: {
        toolbar: Settings,
    },
};
MiniBusiDataMap.Icon = () => {
    return (<span>转换展示</span>);
}